/*
==============================================================================
tectimo PRODUCT TABS JAVASCRIPT

Purpose
- Feature / Specs sticky tab navigation
- Smooth section scrolling
- Active tab detection
- Sub feature carousel controls
- Dynamic slider dots
- Arrow navigation only

Structure
1. Setup
2. Tab Navigation
   - Smooth Scroll
   - Active Tab Detection
3. Sub Feature Sliders
   - Create Dots
   - Arrow Controls
   - Dot Navigation
   - Active Dot Updates

Dependencies
- .tectimo-product-tabs
- .tectimo-tab-links
- .tectimo-tab-contents
- .tectimo-sub-slider
- .tectimo-sub-card
- .tectimo-sub-arrow

==============================================================================
*/

(function(){

/* ==========================================================================
   SETUP
========================================================================== */

const productTabs=document.querySelector('.tectimo-product-tabs');

if(!productTabs)return;

/* ==========================================================================
   TAB NAVIGATION
========================================================================== */

const links=productTabs.querySelectorAll('.tectimo-tab-links a');
const sections=productTabs.querySelectorAll('.tectimo-tab-contents section');

function getScrollOffset(){

  const tabBar=document.querySelector('.tectimo-tab-links');

  return tabBar
    ? tabBar.offsetHeight+70
    : 130;

}

/* SMOOTH SCROLL */

links.forEach(link=>{

  link.addEventListener('click',e=>{

    e.preventDefault();

    const target=productTabs.querySelector(
      link.getAttribute('href')
    );

    if(!target)return;

    window.scrollTo({

      top:
        target.offsetTop-getScrollOffset(),

      behavior:'smooth'

    });

  });

});

/* ACTIVE TAB */

function updateActiveTab(){

  const scrollPos=
    window.scrollY+getScrollOffset();

  if(scrollPos<productTabs.offsetTop){

    links.forEach(link=>{
      link.classList.remove('active');
    });

    return;

  }

  let current=sections[0]?.id;

  sections.forEach(section=>{

    if(scrollPos>=section.offsetTop){

      current=section.id;

    }

  });

  links.forEach(link=>{

    link.classList.toggle(

      'active',

      link.getAttribute('href')===`#${current}`

    );

  });

}

window.addEventListener(
  'scroll',
  updateActiveTab
);

updateActiveTab();


/* ==========================================================================
   SUB FEATURE SLIDERS
========================================================================== */

const sliders=
productTabs.querySelectorAll(
'.tectimo-sub-slider-wrapper'
);

sliders.forEach(wrapper=>{

if(
wrapper.classList.contains('tectimo-static-slider')
&&
window.innerWidth>768
){

return;

}

const slider=
wrapper.querySelector(
'.tectimo-sub-slider'
);

const cards=
wrapper.querySelectorAll(
'.tectimo-sub-card'
);

const dotsContainer=
wrapper.querySelector(
'.tectimo-dots'
);

const left=
wrapper.querySelector(
'.tectimo-sub-arrow.left'
);

const right=
wrapper.querySelector(
'.tectimo-sub-arrow.right'
);


if(
!slider ||
!cards.length ||
!dotsContainer ||
!left ||
!right
){

return;

}


/* CREATE DOTS */

cards.forEach((card,index)=>{

const dot=document.createElement('span');

dot.className='tectimo-dot';

if(index===0){

dot.classList.add('active');

}

dotsContainer.appendChild(dot);

});

const dots=
wrapper.querySelectorAll(
'.tectimo-dot'
);


/* ARROWS */

right.addEventListener('click',()=>{

slider.scrollBy({

left:
slider.clientWidth*.7,

behavior:'smooth'

});

});

left.addEventListener('click',()=>{

slider.scrollBy({

left:
-(slider.clientWidth*.8),

behavior:'smooth'

});

});


/* UPDATE DOTS */

function updateDots(){

const maxScroll=
slider.scrollWidth-slider.clientWidth;

const progress=
slider.scrollLeft/maxScroll;

let index=
Math.round(
progress*(dots.length-1)
);

if(index<0){
index=0;
}

if(index>dots.length-1){
index=dots.length-1;
}

dots.forEach((dot,i)=>{

dot.classList.toggle(
'active',
i===index
);

});

}

slider.addEventListener(
'scroll',
updateDots
);


/* DOT NAVIGATION */

dots.forEach((dot,index)=>{

dot.addEventListener('click',()=>{

slider.scrollTo({

left:
cards[index].offsetLeft,

behavior:'smooth'

});

});

});

});

})();

